export const microgridHeaders = {
  id: "項目",
  time: "時間",
  temperature: "気温(℃)",
  radiation: "日射量(kWh/m²)",
  generation: "発電予測量(kWh)",
  generation_r: "発電電力量(kWh)",
  demand_4: "学校 温水プール・総合体育館 予測量(kWh)",
  demand_4_r: "学校 温水プール・総合体育館 電力量(kWh)",
  demand_1: "富原中学校 予測量(kWh)",
  demand_1_r: "富原中学校 電力量(kWh)",
  demand_2: "富原小学校 予測量(kWh)",
  demand_2_r: "富原小学校 電力量(kWh)",
  demand_3: "富原小学校（暖房）予測量(kWh)",
  demand_3_r: "富原小学校（暖房）電力量(kWh)",
  total_demand: "需要予測量(kWh)",
  total_demand_r: "需要電力量(kWh)",
  purchase: "購入予測量(kWh)",
  purchase_r: "購入電力量(kWh)",
  charge: "蓄電池充電予測量(kWh)",
  discharge: "蓄電池放電予測量(kWh)",
  soc: "蓄電池SOC予測(%)",
  soc_r: "蓄電池SOC実績(%)",
};

export const hironoHeaders = {
  id: "項目",
  time: "-",
  temperature: "-",
  radiation: "-",
  generation: "-",
  generation_r: "-",
  demand_4: "-",
  demand_4_r: "-",
  demand_1: "-",
  demand_1_r: "-",
  demand_2: "-",
  demand_2_r: "-",
  demand_3: "-",
  demand_3_r: "-",
  total_demand: "-",
  total_demand_r: "-",
  purchase: "-",
  purchase_r: "-",
  charge: "-",
  discharge: "-",
  soc: "-",
  soc_r: "-",
};

export const yakubaHeaders = {
  id: "項目",
  time: "時間",
  temperature: "気温(℃)",
  radiation: "日射量(kWh/m²)",
  rooftop_gen: "発電予測量(kWh)屋上",
  rooftop_gen_r: "発電電力量(kWh)屋上",
  carpot_gen: "発電予測量(kWh)カーポート",
  carpot_gen_r: "発電電力量(kWh)カーポート",
  demand: "需要予測量(kWh)",
  demand_r: "需要電力量(kWh)",
  purchase: "購入予測量(kWh)",
  purchase_r: "購入電力量(kWh)",
  charge: "蓄電池充電予測量(kWh)",
  discharge: "蓄電池放電予測量(kWh)",
  soc: "蓄電池SOC予測(%)",
  soc_r: "蓄電池SOC実績(%)",
};

export const keyHeader = ["id"];
export const keyAverage = ["temperature"];

export const keyTotal = [
  "rooftop_gen",
  "rooftop_gen_r",
  "carpot_gen",
  "carpot_gen_r",
  "demand",
  "demand_r",
  "charge",
  "discharge",
  "purchase",
  "purchase_r",
  "generation",
  "generation_r",
  "demand_1",
  "demand_2",
  "demand_3",
  "demand_4",
  "demand_1_r",
  "demand_2_r",
  "demand_3_r",
  "demand_4_r",
  "total_demand",
  "total_demand_r",
];

export const highlightLabels = [
  "発電電力量(kWh)",
  "学校 温水プール・総合体育館 電力量(kWh)",
  "富原中学校 電力量(kWh)",
  "富原小学校 電力量(kWh)",
  "富原小学校（暖房）電力量(kWh)",
  "蓄電池SOC実績(%)",
  "発電電力量(kWh)屋上",
  "発電電力量(kWh)カーポート",
  "需要電力量(kWh)",
  "購入電力量(kWh)",
  "需要電力量(kWh)",
];

export const highlightDatas = [
  "generation_r",
  "demand_4_r",
  "demand_1_r",
  "demand_2_r",
  "demand_3_r",
  "soc_r",
  "rooftop_gen_r",
  "carpot_gen_r",
  "total_demand_r",
  "demand_r",
  "purchase_r",
];

export const noDecimal = ["id", "time", "radiation", "soc", "soc_r"];

export const alwaysHighlightIdx = [5, 7, 9, 11, 15];
export const microgridHighlightIdx = [13, 17, 21];
export const alwaysHighlightNames = [
  "generation_r",
  "demand_4_r",
  "demand_1_r",
  "demand_2_r",
  "demand_3_r",
  "rooftop_gen_r",
  "carpot_gen_r",
  "total_demand_r",
  "purchase_r",
  "soc_r",
  "demand_r",
];
